import React from "react";

import { faker } from "@faker-js/faker";
import Image from "next/image";
import { UserProfile } from "~types/profile";

import DefaultLink from "@/components/elements/link/DefaultLink";
import { Avatar, Box, Rating, Typography } from "@mui/material";

interface UserPreviewProps {
  profile: UserProfile;
}

export const UserPreview = ({ profile }: UserPreviewProps): JSX.Element => {
  const {
    first_name,
    last_name,
    avatar,
    recipe_num,
    avg_rating,
    avatar_thumbnail_252
  } = profile;
  return (
    <DefaultLink
      data-cy={`user_profile user_${profile.pk}_profile`}
      underline={"hover"}
      href={`/user/${profile.pk}`}>
      <Box
        minHeight={{ xs: 189, md: 325 }}
        width={{ xs: 108, md: 150, lg: 180 }}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"flex-start"}
        overflow={"hidden"}>
        <Avatar
          sx={{
            width: { xs: 108, md: 150, lg: 180 },
            height: { xs: 108, md: 150, lg: 180 },
            mb: 1.25,
            alignSelf: "center",
            position: "relative"
          }}>
          {avatar_thumbnail_252 && (
            <Image
              src={avatar_thumbnail_252.toString()}
              layout={"fill"}
              objectFit={"cover"}
              alt="avatar"
            />
          )}
        </Avatar>
        <Typography
          sx={{ mb: 0.5 }}
          color={"#1D2939"}
          maxWidth={"100%"}
          overflow={"hidden"}
          noWrap
          fontSize={{
            xs: 14,
            md: 20
          }}>{`${first_name} ${last_name}`}</Typography>
        <Rating sx={{ mb: 0.5 }} value={avg_rating} size={"small"} readOnly />
        <Box
          display={"flex"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          gap={1}>
          <Avatar
            sx={{ width: 18, height: 18 }}
            src={faker.image.nature(18, 18, true)}
          />{" "}
          <Typography color={"#667085"} fontWeight={400} fontSize={12}>
            {recipe_num} recipes
          </Typography>
        </Box>
      </Box>
    </DefaultLink>
  );
};
